import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const AtIcon = React.memo(
  ({ fill = variables['colors-mc-gray'], width = '24', viewBox = '0 0 24 24' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect id='Rectangle_917' data-name='Rectangle 917' width='24' height='24' fill='none' />
      <path
        id='Path_6300'
        data-name='Path 6300'
        d='M11.575,21.2A8.293,8.293,0,0,1,2.85,12.575,9.443,9.443,0,0,1,12.525,3.05c4.925,0,8.6,3.025,8.6,7.8,0,4.35-2.3,6.075-4.6,6.075a2.716,2.716,0,0,1-2.45-1.275A4.574,4.574,0,0,1,11,16.875a3.972,3.972,0,0,1-4.15-4.3A5.308,5.308,0,0,1,12.275,7.1a3.7,3.7,0,0,1,2.25.675l.1-.425H17l-1.175,5.5c-.225,1.1.025,1.975,1.1,1.975,1.325,0,2.1-1.1,2.1-4.025,0-3.9-3.075-5.725-6.525-5.725a7.2,7.2,0,0,0-7.45,7.5A6.1,6.1,0,0,0,11.575,19.1a9.639,9.639,0,0,0,4.4-1.025L16.8,20.1A13.7,13.7,0,0,1,11.575,21.2ZM11.4,14.525a2.479,2.479,0,0,0,1.825-.7l.8-3.7a2.378,2.378,0,0,0-1.725-.7,2.827,2.827,0,0,0-2.85,2.95C9.45,13.675,10.075,14.525,11.4,14.525Z'
        fill={fill}
        fillRule='evenodd'
      />
    </svg>
  )
);
AtIcon.displayName = 'AtIcon';

export default AtIcon;
